export default __webpack_public_path__ + "0c77ece3715b4a18a2fee3e05cf3d8b2.png";